<template>
    <div class="assets_detail-root">
        <Top></Top>
        <div class="assets_detail-body___1UbSf ">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" style="padding-left: 16px;" :class="active == 'assets_detail' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/index','assets_detail')">
                                <a>{{ $t('m.assets.nav[0]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;" :class="active == 'recharge' ? 'ant-menu-item-selected' : ''" @click="changeTab('/assets/recharge','recharge')">
                                <a>{{ $t('m.assets.nav[1]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;" :class="active == 'withdraw' ? 'ant-menu-item-selected' : ''" @click="changeTab('/assets/withdraw','withdraw')">
                                <a>{{ $t('m.assets.nav[2]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;" :class="active == 'record' ? 'ant-menu-item-selected' : ''" @click="changeTab('/assets/record','record')">
                                <a>{{ $t('m.assets.nav[3]') }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" style="padding-left: 16px;" :class="active == 'account' ? 'ant-menu-item-selected' : ''" @click="changeTab('/assets/account','account')">
                                <a>{{ $t('m.assets.nav[4]') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="nav___1DVi-">
                        <span>{{ $t('m.assets.nav[0]') }}</span>
                        <!--<a @click="changeRoute('/account_detail')">
                            <img src="@/assets/img/zhanghu.png" alt="">
                            <span>账户明细</span>
                        </a>-->
                    </div>
                    <div class="mt-16">
                        <div class="ant-card ant-card-bordered ant-card-wider-padding" style="min-height: 250px;">
                            <div class="ant-card-body">
                                <div class="assetsInfo___1rJu7">
                                    <div class="leftInfo___ps8R3">
                                        <div class="totalAmount___3Yk8e">
                                            <div class="head___6WVr7">
                                                <span>{{ $t('m.assets.text[0]') }}</span>
                                                <a>
                                                    <img src="@/assets/img/yanjing.png" alt="">
                                                </a>
                                            </div>
                                            <div>
                                                <p class="center___3AaKa">
                                                    <span>{{ userInfo.assets / currencyAll[2].priceNew | roundOff(4)}}</span>
                                                    <span>BTC</span>
                                                </p>
                                                <p class="bottom___1sFHz">
                                                    <span>≈ {{ userInfo.assets | roundOff(2) }} </span>
                                                    <span>USDT</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="divider___McpZ1 ant-divider ant-divider-vertical"></div>
                                    <div class="rightInfo___2nZ0m">
                                        <div class="tradeAccount___37zyy">
                                            <div class="head___6WVr7">
                                                <span class="headLeft___1Lbub">{{ $t('m.assets.nav[4]') }}</span>
                                                <a @click="changeRoute('/assets/account')">
                                                    <span>{{ $t('m.assets.text[1]') }}</span>
                                                    <img src="@/assets/img/right_white.png" alt="">
                                                </a>
                                            </div>
                                            <div class="center___3AaKa">
                                                <p class="amount___2DX3s">
                                                    <span>{{ userInfo.assets / currencyAll[2].priceNew | roundOff(4)}}</span>
                                                    <span>BTC</span>
                                                </p>
                                                <p class="currency___1qRqC">
                                                    <span>≈ {{ userInfo.assets | roundOff(2) }} </span>
                                                    <span>USDT</span>
                                                </p>
                                            </div>
                                            <div class="foot___m4JPT">
                                                <a @click="changeRoute('/assets/recharge')">{{ $t('m.assets.nav[1]') }}</a>
                                                <a @click="changeRoute('/assets/withdraw')">{{ $t('m.assets.nav[2]') }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="mt-16">
                        <div class="ant-card ant-card-bordered ant-card-wider-padding" style="min-height: 320px;">
                            <div class="ant-card-body">
                                <div class="DailyTrendNav___ifj-s">
                                    <div class="title___NR4NO">
                                        <span>每日总资产走势</span>
                                        <span>*每日UTC+8 0点更新</span>
                                    </div>
                                    <div>
                                        <span class="ml-8">
                                            <div class=" kc-select  ant-select ant-select-enabled" style="min-width: 66px;">
                                                <div class="ant-select-selection ant-select-selection&#45;&#45;single" @click="typeShow = true">
                                                    <div class="ant-select-selection__rendered">
                                                        <div class="ant-select-selection-selected-value" style="display: block; opacity: 1;">BTC</div>
                                                    </div>
                                                    <span class="ant-select-arrow" style="user-select: none;">
                                                        <i class="ant-select-arrow-icon"></i>
                                                    </span>
                                                </div>
                                                <div class="type-container" v-if="typeShow">
                                                    <div class="type-list type-list-active" @click="typeShow = false">BTC</div>
                                                    <div class="type-list" @click="typeShow = false">USD</div>
                                                </div>
                                            </div>
                                        </span>
                                        <span class="ml-8">
                                            <div class=" kc-select  ant-select ant-select-enabled" style="min-width: 66px;">
                                                <div class="ant-select-selection ant-select-selection&#45;&#45;single" @click="timeShow = true">
                                                    <div class="ant-select-selection__rendered">
                                                        <div class="ant-select-selection-selected-value" style="display: block; opacity: 1;">30天</div>
                                                    </div>
                                                    <span class="ant-select-arrow" style="user-select: none;">
                                                        <i class="ant-select-arrow-icon"></i>
                                                    </span>
                                                </div>
                                                <div class="time-container" v-if="timeShow">
                                                    <div class="time-list" @click="timeShow = false">7天</div>
                                                    <div class="time-list time-list-active" @click="timeShow = false">30天</div>
                                                    <div class="time-list" @click="timeShow = false">1年</div>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                                <div style="padding-top: 70px; text-align: center;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="assetsTotal___1hAMW">
                        <div class="left___3Wx5b item___kwD2r">
                            <div class="totalTrend___20vFr">
                                <p style="margin: 0;">总资产分布</p>
                                <div class="totalCanvas___2LCLn">
                                    <div style="text-align: center;"></div>
                                </div>
                            </div>
                        </div>
                        <div class="right___yeTgN item___kwD2r">
                            <div class="normalQs___3OMvs">
                                <p class="title___NR4NO">常见问题</p>
                                <div class="qsItem___159yd">
                                    <div class="topItem___XEGQs">
                                        <i></i>
                                        <p class="qsTitle___3GHyS">什么是交易账户?</p>
                                    </div>
                                    <div class="bottomItem___26s9m">
                                        <p class="qsContent___2Ti0E">
                                            <span>
                                                交易账户内的资金主要用于币币交易，储蓄账户将资金划转入交易账户方可进行交易，交易账户将资金划转入储蓄账户方可提币转出。
                                                <a>了解更多</a>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="btn___3AMuQ">
                                    <a>
                                        <span>查看更多</span>
                                        <img src="@/assets/img/right_blue.png" alt="">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'
    // import {userAssets} from '@/assets/js/timer/index';

    export default {
        name: "assets_detail",
        components: {
            Top, Bottom
        },
        created() {

        },
        data() {
            return {
                active: 'assets_detail',
                typeShow: false,
                timeShow: false,
                languageShow: false
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/assets_detail.css";
</style>
